import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _flatten from 'lodash/flatten';
import _get from 'lodash/get';
import _isArray from 'lodash/isArray';
import _isEmpty from 'lodash/isEmpty';
import { ACCEPTED_TERMS_KEY, CONTACT_OPT_IN_KEY, DEFAULT_OPT_IN_MESSAGE, FORM_FIELD_TYPES, CHECKBOX_KEY } from './DynamicForm.constants';
import { validateFormFields } from './components/fields/DynamicFormField/DynamicFormField.utils';
import { getId } from '../../../foundation/services';
import { getLocationDisplay } from '../../../locations/components/LocationSelect/LocationSelect.utils';
function getDefaultFieldValue(widgetType) {
  if (widgetType === FORM_FIELD_TYPES.FileUpload) {
    return [];
  }
  return '';
}
export function getLocationId(locationIdProp, fields, formData, locations) {
  var locationSelectField = fields.map(function (field) {
    return _isArray(field) ? field[0] : field;
  }).find(function (_ref) {
    var widgetType = _ref.widgetType;
    return widgetType === FORM_FIELD_TYPES.LocationSelect;
  });
  var sendEmailToSelectedLocation = _get(locationSelectField, 'sendEmailToSelectedLocation', false);
  if (sendEmailToSelectedLocation) {
    var name = locationSelectField.name;
    var locationName = formData[name];
    var location = locations.find(function (currentLocation) {
      return getLocationDisplay(currentLocation) === locationName;
    });
    return getId(location) || locationIdProp;
  }
  return locationIdProp;
}
export function createInitialState(fields, options) {
  var terms = options.terms;
  var flattenedFields = _flatten(fields);
  var formFieldState = flattenedFields.reduce(function (acc, _ref2) {
    var widgetType = _ref2.widgetType,
      name = _ref2.name,
      value = _ref2.value;
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, name, value || getDefaultFieldValue(widgetType)));
  }, {});
  var acceptTermsState = terms ? _defineProperty({}, ACCEPTED_TERMS_KEY, false) : {};
  return _objectSpread(_objectSpread({}, formFieldState), acceptTermsState);
}
export function areAllRequiredFieldsFilled(fieldDefinitions, fieldValues) {
  var flattenedFields = _flatten(fieldDefinitions);
  return flattenedFields.filter(function (field) {
    return field.required && !fieldValues[field.name];
  }).length === 0;
}
export function isFormValid() {
  var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var fieldValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var formErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return areAllRequiredFieldsFilled(fields, fieldValues) && _isEmpty(formErrors);
}
export function getOptInConfiguration(consentSettings) {
  var _ref4 = consentSettings || {},
    _ref4$required = _ref4.required,
    required = _ref4$required === void 0 ? false : _ref4$required;
  return {
    label: DEFAULT_OPT_IN_MESSAGE,
    name: CONTACT_OPT_IN_KEY,
    required: required,
    widgetType: CHECKBOX_KEY
  };
}
export function validateFields(fields, formData, consentSettings) {
  var showOptIn = _get(consentSettings, 'show', false);
  var fieldsToValidate = [].concat(_toConsumableArray(fields), _toConsumableArray(showOptIn ? [getOptInConfiguration(consentSettings)] : []));
  return validateFormFields(fieldsToValidate, formData);
}